import { useSelector } from "react-redux";
import _ from "lodash";

export const useCurrentRental = () => {
  const app = useSelector((state) => ({ ...state.app }));
  const rentals = useSelector((state) => ({ ...state.app.rentals }));
  const currentRental = _.find(rentals, { rental_agreement_number: app.currentRental });
  return currentRental;
};

export const useLoggedInRental = () => {
  const app = useSelector((state) => ({ ...state.app }));
  const loggedInRental = _.get(app, "loginRental", "");
  return loggedInRental;
}